// Name und Versionsnummer des Programms (oben in der Seitenleiste, Anmeldung, Fenstertitel). Die Nummer setzt der
// Build aus RELEASES.md (werkzeuge/vite-programm.ts).
declare const __IMHO_VERSION__: string;

export const PROGRAMMNAME = "IMHO Tools";
export const VERSION: string = typeof __IMHO_VERSION__ === "string" ? __IMHO_VERSION__ : "0.0.0";
